import angular from 'angular';
import uiRouter from 'angular-ui-router';
import picqComponent from './picq.component';

let picqModule = angular.module('picq', [
  uiRouter
])

.component('picq', picqComponent);

export default picqModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/picq/picq.js